import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { incidentTypesApi } from '@/api/index';

export const fetchIncidentTypes = createAsyncThunk(
  'incident-types',
  async (params, thunkAPI) => {
    try {
      const response = await incidentTypesApi.getAllIncidentTypes();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
